export function validateEmail(text) {
    let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    text = String(text).toLowerCase();
    return regex.test(text)
}
  
export function validatePhone(text) {
    let regex = /^\d{7,15}$/
    text = String(text).toLowerCase();
    return regex.test(text)
}
  
export function validatePassword(text) {
    let regex = /^.{3,50}$/
    text = String(text)
    return regex.test(text)
}

export function validateSamePassword(text1, text2) {
    return text1 === text2
}